import Mutations from "./account-plan-mutations";
import Actions from "./account-plan-actions";
import Getters from "./account-plan-getters";
import DefaultState from "./account-plan-state";
const store = {
  namespaced: true,
  state: DefaultState,
  mutations: Mutations,
  actions: Actions,
  getters: Getters
};
export default store;